module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L9W8V3.4648cdb0.jpg";